import Swiper, { Navigation, Lazy, Keyboard, FreeMode } from "swiper";
import MatchHeight from "@tannerhodges/match-height";
import "../../../node_modules/swiper/modules/keyboard/keyboard.scss";
import "../../../node_modules/swiper/modules/navigation/navigation.scss";
import { ajax } from "jquery";
import { gsap } from "gsap";
import { hideSticky } from "./hideSticky";

const AjaxLoadMore = () => {
	// Home Last News Ajax

	const lastarticles = document.getElementById("last-articles");
	if (lastarticles !== null) {
		let button = document.querySelector(".load-more");
		let button2 = document.querySelector(".load-more-page-3");

		button.addEventListener("click", () => {
			button.style.opacity = 0.5;
			let paged = button.getAttribute("data-paged");
			var nonce = button.getAttribute("data-nonce");
			let xhttp = new XMLHttpRequest();

			// Response
			xhttp.onreadystatechange = function () {
				if (this.readyState == 4 && this.status == 200) {
					button.remove(); // remove button
					lastarticles.insertAdjacentHTML("beforeend", this.responseText);
					MatchHeight.add(".list-horizontal .card-horizontal:not(.size--L)");
					let largeElements = gsap.utils.toArray(".card-horizontal.size--L");
					const pubHide = new hideSticky(
						"#sidebar .sidebar-advertising",
						largeElements
					);
					pubHide.init();
					button2.classList.remove("d-none");
				}
			};

			xhttp.open("POST", pokaa.ajaxurl, true);
			xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xhttp.send("action=load_lastnews&paged=" + paged + "&nonce=" + nonce);
		});
	}
};

// Slider Ajax
const AjaxPost = () => {
	let sliderSection = document.querySelectorAll(".section-slider");

	if (sliderSection !== null) {
		//option for observer
		const options = {
			threshold: 0,
			rootMargin: window.innerHeight * 2 + "px", // espace de détection
		};

		sliderSection.forEach((section) => {
			let slider = section.querySelector(".slider-post");
			let parent = section.querySelector(".container");
			let type = slider.getAttribute("data-type");
			let category = null;
			let categories = null;
			let exclude = null;
			let loader = section.querySelector(".loader-slider");

			// Slides déjà rendues en PHP (block avant block-posts) : pas d'AJAX, juste init du slider.
			if (loader === null) {
				let prev = parent.querySelector(".custom-button-prev");
				let next = parent.querySelector(".custom-button-next");
				newPostSlider(slider, next, prev);
				return;
			}

			if (type == "heading") {
				category = slider.getAttribute("data-categoryID");
			} else if (type == "selection") {
				categories = slider.getAttribute("data-categoriesIDs");
				exclude = slider.getAttribute("data-exclude");
			}

			function handleIntersection(entries) {
				entries.map((entry) => {
					if (entry.isIntersecting == true) {
						intersectionObserver.unobserve(entry.target); // stop observation

						// load ajax
						let xhttp = new XMLHttpRequest();
						// Response
						xhttp.onreadystatechange = function () {
							if (this.readyState == 4 && this.status == 200) {
								// console.log('load ajax slider');
								loader.hidden = true;
								slider.insertAdjacentHTML("beforeend", this.responseText);
								let prev = parent.querySelector(".custom-button-prev");
								let next = parent.querySelector(".custom-button-next");
								newPostSlider(slider, next, prev);
							}
						};

						xhttp.open("POST", pokaa.ajaxurl, true);
						xhttp.setRequestHeader(
							"Content-type",
							"application/x-www-form-urlencoded"
						);
						xhttp.send(
							"action=load_slider&type=" +
								type +
								"&category=" +
								category +
								"&categories=" +
								(categories || "") +
								"&exclude=" +
								(exclude || "")
						);
					}
				});
			}

			let intersectionObserver = new IntersectionObserver(
				handleIntersection,
				options
			);

			intersectionObserver.observe(slider);
		});
	}
};

// newPostSlider for Slider Ajax
// slider-post

const newPostSlider = (slider, next, prev) => {
	console.log(slider);

	const slidesPerView = parseFloat(slider.dataset.slidesPerView) || 3;

	new Swiper(slider, {
		modules: [Navigation, Lazy, Keyboard], // configure Swiper to use modules
		spaceBetween: 8,
		slidesPerView: 1.5,
		createElements: true,
		speed: 600,
		centeredSlidesBounds: true,
		centeredSlides: true,
		resistance: false,
		followFinger: false,
		// freeMode: {
		//     enabled: true,
		//     momentumBounce: false,
		//     momentum : true,
		//     momentumRatio : 0.5,
		//     momentumVelocityRatio : 0.5
		//   },
		preloadImages: false, // for lazy load works let it to false !
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 2,
		},
		navigation: {
			nextEl: next,
			prevEl: prev,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		breakpoints: {
			// when window width is >= 480px
			576: {
				slidesPerView: 2,
				centeredSlides: false,
				centeredSlidesBounds: false,
				freeMode: false,
			},

			// when window width is >= 768px
			768: {
				slidesPerView: 3,
				centeredSlides: false,
				freeMode: false,
				centeredSlidesBounds: false,
			},

			991: {
				slidesPerView: slidesPerView,
			},
		},
	});
};

const AjaxSearch = () => {
	// search ajax
	const search = document.getElementById("search-form");
	if (search !== null) {
		// let button = search.querySelector('.btn');
		let input = search.querySelector(".form-control");
		let nonce = search.querySelector("#nonce").value;
		let resultPost = document.getElementById("ajaxSearchResult");
		let resultBtn = document.getElementById("ajaxSearchResultBtn");
		let minlength = 3;
		let inProgress = false;

		input.addEventListener("keyup", (event) => {
			if (input.value.length > minlength && inProgress == false) {
				let xhttp = new XMLHttpRequest();
				let urlBtn = resultBtn.getAttribute("data-url");

				inProgress = true;

				// Response
				xhttp.onreadystatechange = function () {
					if (this.readyState == 4 && this.status == 200) {
						if (this.responseText != 0) {
							resultPost.innerHTML = this.responseText;
							resultBtn.innerHTML =
								"<a href='" +
								urlBtn +
								"?s=" +
								input.value +
								"&post_type=post' class='btn btn-gray' >Voir tous les résultats</a>";
						} else {
							resultPost.innerHTML =
								"<p class='searchNoResult'>Aucun résultat pour votre recherche</p>";
							resultBtn.innerHTML = "";
						}
					}

					// add Delay before do other ajax search
					setTimeout(function () {
						inProgress = false;
					}, 1500);
				};

				xhttp.open("POST", pokaa.ajaxurl, true);
				xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
				xhttp.send("action=search_ajax&s=" + input.value + "&nonce=" + nonce);
			}
		});
	}
};

// Category Hub Ajax (filtre par sous-catégorie + "Voir plus" paginé)
const AjaxHubPosts = () => {
	const section = document.querySelector(".category-hub__section-posts");
	if (section === null) return;

	const categoryId = section.getAttribute("data-category");
	const exclude = section.getAttribute("data-exclude") || "";
	const pillsWrapper = section.querySelector(".category-hub__categories");
	const postsList = section.querySelector(".category-hub__posts-list");
	const moreBtn = section.querySelector(".more-btn");

	if (postsList === null || moreBtn === null) return;

	let isLoading = false;

	// Charge une page d'articles. `append` = true pour "Voir plus" (ajout),
	// false pour un changement de sous-catégorie (remplacement de la liste, avec filtre de chargement).
	const loadPosts = (subcategory, paged, append) => {
		if (isLoading) return;
		isLoading = true;

		// désactive le bouton "Voir plus" pendant le chargement pour éviter les doubles clics
		moreBtn.disabled = true;
		moreBtn.style.opacity = 0.5;

		if (!append) {
			postsList.classList.add("is-loading");
		}

		let xhttp = new XMLHttpRequest();

		xhttp.onreadystatechange = function () {
			if (this.readyState == 4 && this.status == 200) {
				if (append) {
					postsList.insertAdjacentHTML("beforeend", this.responseText);
				} else {
					postsList.innerHTML = this.responseText;
					postsList.classList.remove("is-loading");
				}

				const hasMore = this.getResponseHeader("X-Has-More") === "1";
				moreBtn.classList.toggle("d-none", !hasMore);
				moreBtn.setAttribute("data-subcategory", subcategory);
				moreBtn.setAttribute("data-paged", paged + 1);
				moreBtn.disabled = false;
				moreBtn.style.opacity = 1;

				isLoading = false;
			}
		};

		xhttp.open("POST", pokaa.ajaxurl, true);
		xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		xhttp.send(
			"action=load_hub_posts&nonce=" +
				moreBtn.getAttribute("data-nonce") +
				"&category=" +
				categoryId +
				"&subcategory=" +
				subcategory +
				"&paged=" +
				paged +
				"&exclude=" +
				exclude
		);
	};

	if (pillsWrapper !== null) {
		pillsWrapper.querySelectorAll(".pill").forEach((pill) => {
			pill.addEventListener("click", () => {
				if (pill.classList.contains("active") || isLoading) return;

				pillsWrapper
					.querySelectorAll(".pill")
					.forEach((p) => p.classList.remove("active"));
				pill.classList.add("active");

				const subcategory = pill.getAttribute("data-subcategory") || "";
				loadPosts(subcategory, 1, false);
			});
		});
	}

	moreBtn.addEventListener("click", () => {
		const subcategory = moreBtn.getAttribute("data-subcategory") || "";
		const paged = parseInt(moreBtn.getAttribute("data-paged"), 10) || 2;
		loadPosts(subcategory, paged, true);
	});
};

export { AjaxPost, AjaxSearch, AjaxLoadMore, AjaxHubPosts };
